import find from "lodash/find";
import memoize from "lodash/memoize";
import placeTypeUtils from "../../../../server/lib/open-planet/placeTypeUtils";

const _ = {
  find, memoize,
};

const {
  isContinent,
  isCountry,
  isCity,
  isNeighborhood,
  isRegion,
} = placeTypeUtils;

function buildPlaceDimensions(place = {}) {
  let ancestry = [];

  if (place.ancestry) {
    ancestry = place.ancestry;
  }

  const continent = (isContinent(place) ? place : (_.find(ancestry, isContinent) || {})).name;
  const country = (isCountry(place) ? place : (_.find(ancestry, isCountry) || {})).name;
  const city = (isCity(place) ? place : (_.find(ancestry, isCity) || {})).name;
  const cityId = (isCity(place) ? place : (_.find(ancestry, isCity) || {})).id;
  const neighborhood = (isNeighborhood(place) ?
    place : (_.find(ancestry, isNeighborhood) || {})).name;
  const region = (isRegion(place) ? place : (_.find(ancestry, isRegion) || {})).name;

  const computedUdo = {
    cd1_Continent: continent,
    cd2_Country: country,
    cd3_City: city,
    cd4_Neighborhood: neighborhood,
    cd5_Region: region,
  };

  if (cityId) computedUdo.city_atlas_id = cityId;

  return computedUdo;
}

export default buildPlaceDimensions;



// WEBPACK FOOTER //
// ./assets/shared/udo/buildPlaceDimensions.js